import { ProductTypes } from '@editor/config/constants'
import { UserInfo } from '@editor/interfaces/interfaces'

import { BlueprintEditorTool, BlueprintEditorTools } from '../../definitions'
import SubToolbar from './components/SubToolbar'
import useEditor from './hooks/useEditor'
import useMainCanvas from './hooks/useMainCanvas'

const MaskPCD: BlueprintEditorTool = {
  key: BlueprintEditorTools.MaskPCD,
  authCheck: (userProfile: UserInfo | null, isAllowedToModify: boolean) =>
    (userProfile?.owned_products.includes(ProductTypes.Markly) && isAllowedToModify) || false,
  components: {
    editor: [SubToolbar],
  },
  hooks: {
    useEditor,
    useMainCanvas,
  },
  config: {
    additionalToolbars: {
      cuboidControls: true,
    },
    anchor: {
      notPlaceableOnObjects: true,
    },
  },
}

export default MaskPCD
